import { render, staticRenderFns } from "./Inquery.vue?vue&type=template&id=b49e52ea&scoped=true&"
import script from "./Inquery.vue?vue&type=script&lang=js&"
export * from "./Inquery.vue?vue&type=script&lang=js&"
import style0 from "./Inquery.vue?vue&type=style&index=0&id=b49e52ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49e52ea",
  null
  
)

export default component.exports